export function isValidPrestashopWebserviceKey (value) {
  return /(\w){32}/.test(value)
}
